import { app } from '../../../../../app';
import { Controller } from './edit-role.controller';

app.component('companyManageApplicationRolesEdit', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        role: '<',
        roles: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-role.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/edit/edit-role.component.js